// Entry for /s/:slug/* — picks the LIFF implementation and API base, then boots the shop.
import { useCallback, useMemo } from 'react';
import { useParams } from 'react-router';
import { createApi } from '../api/client.ts';
import { currentFakeUser, fakeLiff, realLiff } from '../liff/liff.ts';
import { resolveApiBase } from '../lib/config.ts';
import { Empty, ToastProvider } from '../ui/index.tsx';
import { ShopBoot } from './boot.tsx';
import { ShopApp } from './ShopApp.tsx';

let API_BASE = '';
let CONFIG_ERROR: string | null = null;
try {
  API_BASE = resolveApiBase({ PROD: import.meta.env.PROD, VITE_API_BASE: import.meta.env.VITE_API_BASE as string | undefined });
} catch (e) {
  CONFIG_ERROR = (e as Error).message;
}
const FAKE = import.meta.env.VITE_FAKE_LIFF === '1';
const FAKE_CHANNEL = (import.meta.env.VITE_FAKE_CHANNEL as string | undefined) ?? '1650000000';

export function ShopRoot() {
  const { slug = '' } = useParams();
  const liff = useMemo(() => (FAKE ? fakeLiff(FAKE_CHANNEL, currentFakeUser()) : realLiff()), []);
  const makeApi = useCallback(
    (o: { getToken: () => string | null; onAuthError: (code: string) => void }) => createApi({ baseUrl: API_BASE, slug, ...o }),
    [slug],
  );
  if (CONFIG_ERROR) {
    return <div className="app"><Empty title="ระบบยังตั้งค่าไม่ครบ" text={CONFIG_ERROR} /></div>;
  }
  return (
    <ToastProvider>
      <ShopBoot slug={slug} liff={liff} makeApi={makeApi}>
        <ShopApp />
      </ShopBoot>
    </ToastProvider>
  );
}
